'use client'
import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Card, Row, Typography } from '@repo/ui/components'
import { useState } from 'react'
import { RegisterForm } from './register.form'
import { RegisterOtp } from './register.otp'
import { IRegisterInfo } from './register.types'

export const RegisterContainer = () => {
  const { t } = useTranslate()
  const [step, setStep] = useState<'otp' | 'register'>('register')
  const [registerInfo, setRegisterInfo] = useState<IRegisterInfo | null>(null)
  const handleRegisterSuccess = (
    mobileOrEmail: string,
    invitationCode?: string,
    type?: 'email' | 'mobile',
    otp?: number,
  ) => {
    setRegisterInfo({ mobileOrEmail, invitationCode, type, otp })
    setStep('otp')
  }

  return (
    <div className='px-md'>
      {step === 'otp' && registerInfo && (
        <RegisterOtp
          mobileOrEmail={registerInfo.mobileOrEmail || ''}
          invitationCode={registerInfo.invitationCode || ''}
          handleBack={() => setStep('register')}
          type={registerInfo.type || 'mobile'}
          otp={registerInfo.otp}
        />
      )}
      {step === 'register' && (
        <Card className='p-xl rounded-sm'>
          <Row className='justify-between'>
            <Typography size='2xl' weight='bold'>
              {t('common_register')}
            </Typography>
            <Row className='gap-xs w-fit'>
              <Typography
                size='2xs'
                weight='regular'
                className='text-neutral-surface-80'
              >
                {t('registerPage_alreadyRegistered')}
              </Typography>
              <ButtonLink href='/auth/login' size='sm' color='base'>
                {t('common_login')}
              </ButtonLink>
            </Row>
          </Row>

          <RegisterForm
            onSuccess={handleRegisterSuccess}
            registerInfo={registerInfo}
          />
        </Card>
      )}
    </div>
  )
}
